









import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class SectionWrappe extends Vue {
  @Prop({ default: 12 })
  private paddingTop?: number;
  @Prop({ default: 0 })
  private paddingBottom?: number;

  private mounted() {}
}
